<template>
  <div>
    <vs-table :data="users">

      <template slot="thead">
        <vs-th :key="i" class="text-base" v-for="(title, i) in header"
               :class="{'float-right': title === $t('users.table.actions')}">{{ title }}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.username">
            {{ tr.name }}
          </vs-td>
          <vs-td :data="tr.surname">
            {{ tr.surname }}
          </vs-td>
          <vs-td :data="tr.email">
            <a :href="`mailto:${tr.email}`">
              {{ tr.email }}
            </a>
          </vs-td>
          <vs-td :data="tr.phone">
            <a :href="`tel:${tr.phone}`">
              {{ tr.phone }}
            </a>
          </vs-td>
          <vs-td :data="tr.roles[0].name">
            <span :key="role.id" v-for="role in tr.roles"><vs-chip
              class="text-black">{{ role.name | role }}</vs-chip></span>
          </vs-td>
          <vs-td>
            <vx-tooltip :text="$t(`buttons${tr.is_enabled ? '.disable' : '.enable'}`)" position="top">
              <toggle-button :height="25" :labels="{checked: 'Enabled', unchecked: 'Disabled'}" :sync="true" :value="tr.is_enabled"
                             :width="80"
                             @change="$emit('changeStatus', tr)"/>
            </vx-tooltip>
          </vs-td>
          <vs-td class="text-right">
            <div class="flex justify-end">
              <vx-tooltip :text="$t('buttons.edit')" position="top">
                <base-button @click="$emit('edit', tr)" class="self-end px-3 mx-px" icon="pen"/>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>

  export default {
    name: 'UsersTable',
    components: {},
    props: {
      header: {
        type: Array,
        required: true
      },
      users: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      startLoading () {
        this.$vs.loading({
          container: this.$refs.usersTableContent,
        })
      },
      stopLoading () {
        this.$vs.loading.close(this.$refs.usersTableContent)
      },
    },
    watch: {
      loading (newValue) {
        if (newValue) this.startLoading()
        else this.stopLoading()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
